/**
 * How a customer is named in a picker. A synthetic customer (a test, E2E or demo tenant, flagged by
 * Avrio) says so, so nobody mistakes it for a real one: a plain string keeps the Select searchable by
 * name, and "(synthetic)" is part of what the person sees and can type.
 */
export const customerLabel = (customer: {
  name: string;
  isSynthetic?: boolean;
}): string =>
  customer.isSynthetic ? `${customer.name} (synthetic)` : customer.name;
